import { Button } from '@app/components/various/Button';
import { Visibility } from '@app/components/various/Icons';
import { compiledPaths } from '@app/paths';
import { Id } from '@typings';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
  name: string;
  slug: string;
  id: Id;
}

export const PreviewListItem = (props: Props) => {
  const { name, slug, id } = props;
  const { t } = useTranslation(['common']);

  return (
    <div className="grid w-full grid-rows-[repeat(2,_auto)] rounded-regular bg-neutral-96/85 p-3">
      <div className="flex items-center justify-between gap-5 overflow-hidden whitespace-nowrap">
        <div className="overflow-hidden">
          <div className="flex items-center gap-2 overflow-hidden">
            <div className="truncate body-1">{name}</div>
            <Link target="_blank" to={compiledPaths.CMS_PREVIEW({ pageId: id })} className="truncate body-2">
              {`/${slug}`}
            </Link>
          </div>
        </div>
        <div>
          <Button
            icon={Visibility}
            as={Link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('common:preview')}
            variant="text"
            color="secondary"
            size="medium"
            to={compiledPaths.CMS_PREVIEW({ pageId: id })}
          >
            {t('common:preview')}
          </Button>
        </div>
      </div>
    </div>
  );
};
